import { createSafeContext, GetStylesApi } from '@mantine/core';

interface GetChangeValue {
  pct: number
  min: number
  max: number
  step: number
  precision?: number
}

export function getChangeValue({pct, min, max, step, precision}: GetChangeValue) {
  const dx = pct * (max - min)
  const nextValue = (dx !== 0 ? Math.round(dx / step) * step : 0) + min
  return precision != null ? Number(nextValue.toFixed(precision)) : nextValue
}

export function getClientPosition(event: any) {
  if ('TouchEvent' in window && event instanceof window.TouchEvent) {
    const touch = event.touches[0]
    return touch?.clientX
  }
  return event.clientX
}

interface GetPosition {
  value: number
  min: number
  max: number
}

/** returns a position in 1 to 100 coordinates */
export function getPosition({value, min, max}: GetPosition) {
  const position = ((value - min) / (max - min)) * 100
  return Math.min(Math.max(position, 0), 100)
}


export type SliderStylesNames =
  | 'root'
  | 'label'
  | 'thumb'
  | 'trackContainer'
  | 'track'
  | 'bar'
  | 'markWrapper'
  | 'mark'
  | 'markLabel'
  | 'markCustom';

export type SliderCssVariables = {
  root: '--slider-size' | '--slider-color' | '--slider-thumb-size' | '--slider-radius';
};

interface SliderContextValue {
  getStyles: GetStylesApi<{
    stylesNames: SliderStylesNames;
    props: any;
    ref: any;
    vars: any;
    variant: any;
  }>;
}

export const [SliderProvider, useSliderContext] = createSafeContext<SliderContextValue>(
  'SliderProvider was not found in tree'
);

export function getPrecision(step: number) {
  if (!step) return undefined;
  const split = step.toString().split('.');
  return split.length > 1 ? split[1]!.length : undefined;
}
